import {ArtifactoryDao} from '../artifactory_dao';

export function DependencyDeclarationDao(RESOURCE, ArtifactoryDaoFactory) {
    return ArtifactoryDaoFactory()
            .setDefaults({method: 'POST'})
            .setPath(RESOURCE.DEPENDENCY_DECLARATION)
            .getInstance();
}


// WEBPACK FOOTER //
// ./data/dao/dependency_declaration_dao.js